// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"UsersForm_fullWidth__-CrqU","error":"UsersForm_error__2pXfb","formItem":"UsersForm_formItem__2RDvG"};